// src/components/MonthlyMVP.js
import React, { useMemo } from 'react';
import { TrendingUp, Percent, Swords } from 'lucide-react';
import { computeMonthlyMVP } from '../utils/mvpCalculations';

const AWARDS = [
  { key: 'ratingKing', label: 'Elo 상승왕', icon: TrendingUp, color: 'text-primary', format: v => `+${v}` },
  { key: 'winRateKing', label: '승률왕', icon: Percent, color: 'text-primary', format: v => `${v}%` },
  { key: 'matchKing', label: '다승왕', icon: Swords, color: 'text-primary', format: v => `${v}승` },
];

export default function MonthlyMVP({ players, matches, setSelectedPlayerId, setCurrentView }) {
  const mvp = useMemo(() => computeMonthlyMVP(players, matches), [players, matches]);

  if (!mvp) return null;

  const activeAwards = AWARDS.filter(a => mvp[a.key]?.player);
  if (activeAwards.length === 0) return null;

  return (
    <div className="bg-card rounded-lg border border-border p-4 mb-4">
      <p className="text-xs font-medium text-muted-foreground mb-3">{mvp.month} 이달의 선수</p>
      <div className={`grid gap-3 ${activeAwards.length === 3 ? 'grid-cols-3' : activeAwards.length === 2 ? 'grid-cols-2' : 'grid-cols-1'}`}>
        {activeAwards.map(({ key, label, icon: Icon, color, format }) => {
          const data = mvp[key];
          return (
            <button
              key={key}
              onClick={() => {
                setSelectedPlayerId(data.player.id);
                setCurrentView('playerDetail');
              }}
              className="text-center group"
            >
              <Icon className={`h-4 w-4 mx-auto mb-1.5 ${color} opacity-80`} />
              <p className="text-xs text-muted-foreground mb-0.5">{label}</p>
              <p className="text-sm font-semibold text-foreground group-hover:text-primary transition-colors truncate">
                {data.player.name}
              </p>
              <p className={`text-xs font-medium ${color} mt-0.5`}>{format(data.value)}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
